//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { PojoMap } from 'pojo-maps';
import { PojoSet } from 'pojo-sets';

import { RequestRightsModalAction } from '@galleries/actions/requestRightsModalActions';
import { REQUEST_RIGHTS_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IRequestRightsModal } from '@galleries/models/requestRightsModalModel';

export const initialState: IRequestRightsModal = {
  isOpen: false,
  selectedItems: PojoMap.empty(),
  materializedItems: [],
  hasChromeExtension: false,
  itemsPendingApproval: {},
};

export default function RequestRightsModalReducer(
  state: IRequestRightsModal = initialState,
  action: RequestRightsModalAction,
): IRequestRightsModal {
  switch (action.type) {
    case REQUEST_RIGHTS_MODAL_ACTIONS.OPEN_MODAL:
      return {
        ...state,
        isOpen: true,
        materializedItems: action.materializedItems,
      };

    case REQUEST_RIGHTS_MODAL_ACTIONS.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
      };

    case REQUEST_RIGHTS_MODAL_ACTIONS.SELECT_IMAGE:
      return {
        ...state,
        selectedItems: PojoMap.set(
          state.selectedItems,
          action.selectedItem.id,
          action.selectedItem,
        ),
      };

    case REQUEST_RIGHTS_MODAL_ACTIONS.DESELECT_IMAGE:
      return {
        ...state,
        selectedItems: PojoMap.remove(
          state.selectedItems,
          action.selectedItem.id,
        ),
      };

    case REQUEST_RIGHTS_MODAL_ACTIONS.HAS_CHROME_EXTENSION:
      return {
        ...state,
        hasChromeExtension: action.extensionPresent,
      };

    case REQUEST_RIGHTS_MODAL_ACTIONS.RESET_MODAL:
      return initialState;

    case REQUEST_RIGHTS_MODAL_ACTIONS.IS_PENDING_APPROVAL:
      return {
        ...state,
        itemsPendingApproval: PojoSet.add(
          state.itemsPendingApproval,
          action.itemId,
        ),
      };

    default:
      return state;
  }
}
